import $DB from '../../util/debounce'
export default {
  data() {
    return {
      navList: ['活动报名记录', '会员推荐记录', '我收藏的会员', '我的举报建议', '会员尊享服务', '诚信认证', 'VIP特权'],
      i: 0,
      userInfo: {},
      complaint: {
        ts_mg_id: '',
        ts_desc: '',
        ts_phone: '',
        code: '',
      }, //投诉信息
      codeTxt: '获取验证码',
      sending: true,
      second: 60,
      disabled: false,
      page: 1, //分页
      pages: '', //总页数
      consumeList: [], //消费列表
      recommendList: [], //会员推荐记录
      collectList: [], //收藏列表
      recordList: [], //活动报名记录
      enjoyMessage: {},
      approveMessage: {}, //认证信息
      privilege: null, //对比图
    }
  },
  created() {
    this.getUserInfo()
    this.getConsumeList()
    this.getRecommendList()
    this.getRecordList()
    this.getCollectList()
  },
  methods: {
    //去认证
    goApprove() {
      this.$router.push({ path: '/applyInitiation' })
    },
    //去详情
    goActivityMessage(id) {
      this.$router.push({ path: '/activityMessage', query: { id } })
    },
    //去会员详情
    goVipMessage(id) {
      this.$router.push({ path: '/vipMessage', query: { id } })
    },
    //获取验证码
    getCode: $DB(function () {
      if (!this.sending) return
      if (!this.complaint.ts_phone) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.complaint.ts_phone.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      this.$axios
        .post('/api/login/tel_code', {
          phone: this.complaint.ts_phone,
        })
        .then((res) => {
          this.sending = false
          this.disabled = true
          if (res.data.code == 0) {
            this.timeDown()
          }
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
        })
    }),
    timeDown() {
      let result = setInterval(() => {
        --this.second
        this.codeTxt = this.second + 'S'
        if (this.second < 0) {
          clearInterval(result)
          this.sending = true
          this.disabled = false
          this.second = 60
          this.codeTxt = '获取验证码'
        }
      }, 1000)
    },
    //提交投诉
    submitComplaint: $DB(function () {
      if (!this.complaint.ts_mg_id) {
        this.$message.error('请输入投诉的芒果ID')
        return
      }
      if (!this.complaint.ts_desc) {
        this.$message.error('请输入投诉内容')
        return
      }
      if (!this.complaint.ts_phone.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.complaint.code) {
        this.$message.error('请输入验证码')
        return
      }
      this.$axios.post('/api/users/leaveWordTs', this.complaint).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
    goMe() {
      this.$router.push('/me')
    },
    changeI(index) {
      if (index == 4) {
        if (this.userInfo.is_member == 0) {
          this.$router.push('/applyInitiation')
          return
        }
      } else if (index == 5) {
        this.getApprove()
      } else if (index == 6) {
        this.getPrivilege()
      }
      this.i = index
    },
    //获取特权
    getPrivilege() {
      this.$axios.post('/api/ban/vip').then((res) => {
        if (res.data.code === 0) {
          this.privilege = res.data.data
        }
      })
    },
    //获取认证信息
    getApprove() {
      this.$axios.post('/api/ban/icon').then((res) => {
        if (res.data.code === 0) {
          this.approveMessage = res.data.data
        }
      })
    },
    //获取个人信息
    getUserInfo() {
      this.$axios.post('/api/users/getUserInfo').then((res) => {
        if (res.data.code === 0) {
          this.userInfo = res.data.data
        }
      })
    },
    //获取尊享服务
    getConsumeList() {
      this.$axios.post('/api/users/zxfw').then((res) => {
        if (res.data.code === 0) {
          this.enjoyMessage = res.data.data
        }
      })
    },
    //获取推荐记录
    getRecommendList() {
      this.$axios.post('/api/member/memberRecList').then((res) => {
        if (res.data.code === 0) {
          this.recommendList = res.data.data.memberList
        } else {
          this.recommendList = []
        }
      })
    },
    //获取报名列表
    getRecordList() {
      this.$axios
        .post('/api/users/act_log', {
          type: 3,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.recordList = res.data.data
          } else {
            this.recordList = []
          }
        })
    },
    //获取收藏列表
    getCollectList() {
      this.$axios.post('/api/users/collectList').then((res) => {
        if (res.data.code === 0) {
          this.collectList = res.data.data.collectList
        } else {
          this.collectList = []
        }
      })
    },
  },
}
